import { post } from '../index';

export const bulkAddUserToProject = data => {
  return post('/projects/bulk-share', data);
};
